/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function Purpose() {
    const tableName = 'Purpose';
    const [data, setData] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
    }, [candidate_id]);

    return (
        <>
            <div>
                <span>
                    <S.Box>
                        <h4>Immigration purpose</h4>
                        {/* <h4>Region</h4> */}
                        <S.Value>{data?.purpose}</S.Value>
                        {/* <p className={styles.value}> {data?.region}</p> */}
                    </S.Box>
                </span>
            </div>
        </>
    );
}
